import React, { useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useSecurity } from '../context/SecurityContext';
import { useAuth } from '../context/AuthContext';
import { useInactivityLogout } from '../hooks/useInactivityLogout';
import { clearAllAuth } from '../utils/cookies';
import { ADMIN_LOGIN_PATH } from '../context/SecurityContext';

/**
 * Componente que cierra sesión automáticamente tras 15 minutos de inactividad.
 * Aplica tanto en panel de administración como en sesión de cliente.
 * Limpia tokens y recarga para cerrar sesión en frontend y backend (token inválido).
 */
export default function InactivityLogout() {
  const location = useLocation();
  const { isAuthenticated: isAdmin } = useSecurity();
  const { isAuthenticated: isCustomer } = useAuth();
  const hasLoggedOutRef = useRef(false);

  const isOnLoginPage =
    location.pathname === '/login' ||
    location.pathname === '/registro' ||
    location.pathname === ADMIN_LOGIN_PATH;

  const isLoggedIn = (isAdmin || isCustomer) && !isOnLoginPage;

  const handleInactivityLogout = React.useCallback(() => {
    if (hasLoggedOutRef.current) return;
    hasLoggedOutRef.current = true;

    clearAllAuth();
    sessionStorage.setItem('inactivity_logout', 'true');

    const redirectPath = location.pathname.startsWith('/admin') ? ADMIN_LOGIN_PATH : '/login';
    window.location.href = redirectPath;
  }, [location.pathname]);

  useInactivityLogout(isLoggedIn, handleInactivityLogout);

  return null;
}
